import * as React from "react";
import { scoreHelper } from "../../../../helpers";
import { MiniScore } from "../MiniScore";
export const MiniLiveScore = (props) => {
    const score = scoreHelper(props.event);
    return React.createElement(MiniScore, { score1: score.homeScore, score2: score.awayScore, sportId: props.event.sportId, scoreboard: props.event.scoreboard, componentPrefix: props.componentPrefix });
};
//# sourceMappingURL=MiniLiveScore.js.map